<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <header class="flex">
            <strong class="flex_fill">{{title}}</strong>
            <button class="button button-link button-icon" @click="$emit('close')">
              <span class="material-icons">close</span>
            </button>
          </header>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  export default {
    props:['title']
  }

</script>

<style lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .modal-container {
    width: 500px;
    margin: auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 10px 80px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;

    header {
      margin: 0 0 20px;

      strong{
        font-size: 1.1rem;
      }
    }
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media #{$phone} {
    .modal-container {
      width: calc(100% - 20px);
    }
  }

</style>